<ngx-spinner bdColor="rgba(0,0,0,0)"
             size="medium"
             color="#000000"
             type="ball-spin-clockwise">
</ngx-spinner>

<div class="modal-signup modal-content" *ngIf="Mode=='New'">
  <div>
    <div class="card col-xl-12 col-lg-12 col-md-12 col-sm-12  my-profile-form document">


      <div class="card-header wh-header padding-bottom-0px">

        Add Day <div class="badge badge-search-new"><h4 class="margin-bottom-0px margin-top-1px">{{DOC}}</h4></div>

        <button type="button" class="close" data-dismiss="modal"
                (click)="activeModal.dismiss('Cross click')"
                aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="card-body padding-bottom-0px padding-right-0px margin-left-0px">
        <form class="form" (ngSubmit)="onSubmit()" novalidate="" #f="ngForm">
          <div class="modal-body padding-top-0px">








            <div class="row margin-left-auto">
              <div class="col-md-12 padding-l-0px">

                <!--<div class="card-header wh-header card-header-bg padding-left-7px padding-top-6px margin-top-10">
                  Emergency Contact(Family)


                </div>-->
                <div class="row">
                  <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                    <div class="row">
                      <div class="col-md-4 text-align-right padding-left-0px margin-top-5px">
                        <label for="diaplayName" *ngIf="DOC==1">Count</label>
                        <label for="diaplayName" *ngIf="DOC==2 || DOC==3 || DOC==4">Embryo Count</label>
                        <label for="diaplayName" *ngIf="DOC==5 || DOC==6">Blastocyst Count</label>
                      </div>
                      <div class="col-md-4 ">
                        <CodeTypeValue CodeType="1to20" id="CurrentSaveEmbryoGradingInfoRequest.EmbryoCount"
                                       [(ngModel)]="CurrentSaveEmbryoGradingInfoRequest.EmbryoCount" SelectedValue=""
                                       name="CurrentSaveEmbryoGradingInfoRequest.EmbryoCount" required>

                        </CodeTypeValue>

                      </div>
                    </div>


                  </div>
                </div>
                <div class="row" *ngIf="DOC==2">
                  <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                    <div class="row">
                      <div class="col-md-4 text-align-right margin-top-5px">
                        <label for="diaplayName">Cell Count</label>
                      </div>
                      <div class="col-md-4 ">

                        <CodeTypeValue CodeType="1to20" id="CurrentSaveEmbryoGradingInfoRequest.CellCount"
                                       [(ngModel)]="CurrentSaveEmbryoGradingInfoRequest.CellCount" SelectedValue=""
                                       name="CurrentSaveEmbryoGradingInfoRequest.CellCount" required>

                        </CodeTypeValue>
                      </div>
                    </div>


                  </div>
                </div>
                <div class="row" *ngIf="DOC==3">
                  <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                    <div class="row">
                      <div class="col-md-4 text-align-right margin-top-5px padding-left-0px">
                        <label for="diaplayName">Cell Count / Cell Stage</label>
                      </div>
                      <div class="col-md-4 ">

                        <CodeTypeValue CodeType="CECNT" id="CurrentSaveEmbryoGradingInfoRequest.CellStage"
                                       [(ngModel)]="CurrentSaveEmbryoGradingInfoRequest.CellStage" SelectedValue=""
                                       name="CurrentSaveEmbryoGradingInfoRequest.CellStage" required>

                        </CodeTypeValue>
                      </div>
                    </div>


                  </div>
                </div>
                <div class="row" *ngIf="DOC==4">
                  <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                    <div class="row">
                      <div class="col-md-4 text-align-right margin-top-5px padding-left-0px">
                        <label for="diaplayName">Cell Count / Cell Stage</label>
                      </div>
                      <div class="col-md-4 ">

                        <CodeTypeValue CodeType="CECNT" id="CurrentSaveEmbryoGradingInfoRequest.CellStage"
                                       [(ngModel)]="CurrentSaveEmbryoGradingInfoRequest.CellStage" SelectedValue=""
                                       name="CurrentSaveEmbryoGradingInfoRequest.CellStage" required>

                        </CodeTypeValue>
                      </div>
                    </div>


                  </div>
                </div>
                <div class="row" *ngIf="DOC==5 || DOC==6">
                  <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                    <div class="row">
                      <div class="col-md-4 text-align-right margin-top-5px">
                        <label for="diaplayName">Stage</label>
                      </div>
                      <div class="col-md-4 ">

                        <!--<input type="number" class="form-control"
                        placeholder="Details" maxlength="20" minlength="1" pattern="^[\sa-zA-Z0-9,._\-?]*$">-->
                        <CodeTypeValue CodeType="D{{DOC}}STG" id="CurrentSaveEmbryoGradingInfoRequest.CellStage"
                                       [(ngModel)]="CurrentSaveEmbryoGradingInfoRequest.CellStage" SelectedValue=""
                                       name="CurrentSaveEmbryoGradingInfoRequest.CellStage" required>

                        </CodeTypeValue>
                      </div>
                    </div>


                  </div>
                </div>
                <div class="row">
                  <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                    <div class="row">
                      <div class="col-md-4 text-align-right margin-top-5px">
                        <label *ngIf="DOC==1">OutCome</label>
                        <label for="diaplayName" *ngIf="DOC==2 || DOC==3 || DOC==4">Grade</label>
                        <label for="diaplayName" *ngIf="DOC==5 || DOC==6">Grade (ICM+TE)</label>
                      </div>
                      <div class="col-md-3">
                        <CodeTypeValue CodeType="D{{DOC}}GR1" id="CurrentSaveEmbryoGradingInfoRequest.Grade1" PassType="Long"
                                       [(ngModel)]="CurrentSaveEmbryoGradingInfoRequest.Grade1" SelectedValue=""
                                       name="CurrentSaveEmbryoGradingInfoRequest.Grade1" required></CodeTypeValue>

                      </div>
                      <div class="col-md-3" *ngIf="DOC>4">
                        <CodeTypeValue CodeType="D{{DOC}}GR2" id="CurrentSaveEmbryoGradingInfoRequest.Grade2"
                                       [(ngModel)]="CurrentSaveEmbryoGradingInfoRequest.Grade2" SelectedValue=""
                                       name="CurrentSaveEmbryoGradingInfoRequest.Grade2" required></CodeTypeValue>

                      </div>
                      <!--<div class="col-md-3" *ngIf="DOC>4">
                        <CodeTypeValue CodeType="D{{DOC}}GR3" id="CurrentSaveEmbryoGradingInfoRequest.Grade3"
                                       [(ngModel)]="CurrentSaveEmbryoGradingInfoRequest.Grade3" SelectedValue=""
                                       name="CurrentSaveEmbryoGradingInfoRequest.Grade3" required></CodeTypeValue>

                      </div>-->
                    </div>


                  </div>
                </div>
                <div class="row" *ngIf="DOC>1">
                  <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                    <div class="row">
                      <div class="col-md-4 text-align-right margin-top-5px">
                        <label for="diaplayName">Frozen</label>
                      </div>
                      <div class="col-md-4 ">

                        <!--<input type="number" class="form-control"
                        placeholder="Details" maxlength="20" minlength="1" pattern="^[\sa-zA-Z0-9,._\-?]*$">-->
                        <!--<input type="number" class="form-control" id="CurrentSaveEmbryoGradingInfoRequest.FrozenCount"
                               [(ngModel)]="CurrentSaveEmbryoGradingInfoRequest.FrozenCount"
                               name="CurrentSaveEmbryoGradingInfoRequest.FrozenCount"
                               placeholder="Count" maxlength="20" minlength="1" #Ntimes="ngModel" pattern="^[\sa-zA-Z0-9,._\-?]*$">
                        <small class="form-text text-danger"
                               *ngIf="(!Ntimes.valid && (Ntimes.dirty || Ntimes.touched) && Ntimes.errors.required)">(Field cannot be left blank)</small>
                        <small class="form-text text-danger"
                               *ngIf="(!Ntimes.valid && Ntimes.errors.pattern)">(special characters are not allowed)</small>-->
                        <input type="text" class="form-control" id="CurrentSaveEmbryoGradingInfoRequest.FrozenCount"
                               [(ngModel)]="CurrentSaveEmbryoGradingInfoRequest.FrozenCount"
                               name="CurrentSaveEmbryoGradingInfoRequest.FrozenCount"
                               placeholder="Count" maxlength="5" minlength="1" #Ntimes="ngModel" pattern="^[\0-9,._\-?]*$">
                        <small class="form-text text-danger"
                               *ngIf="(!Ntimes.valid && (Ntimes.dirty || Ntimes.touched) && Ntimes.errors.required)">(Field cannot be left blank)</small>
                        <small class="form-text text-danger"
                               *ngIf="(!Ntimes.valid && Ntimes.errors.pattern)">(only numbers are allowed)</small>

                      </div>
                    </div>


                  </div>
                </div>
                <div class="row" *ngIf="DOC>1">
                  <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                    <div class="row">
                      <div class="col-md-4 text-align-right margin-top-5px">
                        <label for="diaplayName">Discarded</label>
                      </div>
                      <div class="col-md-4 ">

                        <!--<input type="number" class="form-control"
                        placeholder="Details" maxlength="20" minlength="1" pattern="^[\sa-zA-Z0-9,._\-?]*$">-->
                        <!--<input type="number" class="form-control" id="CurrentSaveEmbryoGradingInfoRequest.DiscardedCount"
                               [(ngModel)]="CurrentSaveEmbryoGradingInfoRequest.DiscardedCount"
                               name="CurrentSaveEmbryoGradingInfoRequest.DiscardedCount"
                               placeholder="Count" maxlength="20" minlength="1" #Ntimes="ngModel" pattern="^[\sa-zA-Z0-9,._\-?]*$">
                        <small class="form-text text-danger"
                               *ngIf="(!Ntimes.valid && (Ntimes.dirty || Ntimes.touched) && Ntimes.errors.required)">(Field cannot be left blank)</small>
                        <small class="form-text text-danger"
                               *ngIf="(!Ntimes.valid && Ntimes.errors.pattern)">(special characters are not allowed)</small>-->
                        <input type="text" class="form-control" id="CurrentSaveEmbryoGradingInfoRequest.DiscardedCount"
                               [(ngModel)]="CurrentSaveEmbryoGradingInfoRequest.DiscardedCount"
                               name="CurrentSaveEmbryoGradingInfoRequest.DiscardedCount"
                               placeholder="Count" maxlength="5" minlength="1" #Ntimes="ngModel" pattern="^[\0-9,._\-?]*$">
                        <small class="form-text text-danger"
                               *ngIf="(!Ntimes.valid && (Ntimes.dirty || Ntimes.touched) && Ntimes.errors.required)">(Field cannot be left blank)</small>
                        <small class="form-text text-danger"
                               *ngIf="(!Ntimes.valid && Ntimes.errors.pattern)">(only numbers are allowed)</small>
                      </div>
                    </div>


                  </div>
                </div>
                <div class="row" *ngIf="DOC>1">
                  <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                    <div class="row">
                      <div class="col-md-4 text-align-right margin-top-5px">
                        <label for="diaplayName">Transfer</label>
                      </div>
                      <div class="col-md-4 ">

                        <!--<input type="number" class="form-control"
                        placeholder="Details" maxlength="20" minlength="1" pattern="^[\sa-zA-Z0-9,._\-?]*$">-->
                        <CodeTypeValue CodeType="1to20" id="CurrentSaveEmbryoGradingInfoRequest.TransferCount"
                                       [(ngModel)]="CurrentSaveEmbryoGradingInfoRequest.TransferCount" SelectedValue=""
                                       name="CurrentSaveEmbryoGradingInfoRequest.TransferCount" required></CodeTypeValue>

                      </div>
                    </div>


                  </div>
                </div>
                <div class="row" *ngIf="Doc==1 || DOC==2 || DOC==3 || DOC==4">
                  <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                    <div class="row">
                      <div class="col-md-4 text-align-right margin-top-5px">
                        <label for="diaplayName">Fragmentation</label>
                      </div>
                      <div class="col-md-4 ">

                        <!--<input type="number" class="form-control"
                        placeholder="Details" maxlength="20" minlength="1" pattern="^[\sa-zA-Z0-9,._\-?]*$">-->
                        <!--<input type="number" class="form-control" id="CurrentSaveEmbryoGradingInfoRequest.Fragmentation "
                               [(ngModel)]="CurrentSaveEmbryoGradingInfoRequest.Fragmentation "
                               name="CurrentSaveEmbryoGradingInfoRequest.Fragmentation"
                               placeholder="Count" maxlength="20" minlength="1" #Fragmentation="ngModel" pattern="^[\sa-zA-Z0-9,._\-?]*$">
                        <small class="form-text text-danger"
                               *ngIf="(!Fragmentation.valid && (Fragmentation.dirty || Fragmentation.touched) && Fragmentation.errors.required)">(Field cannot be left blank)</small>
                        <small class="form-text text-danger"
                               *ngIf="(!Fragmentation.valid && Fragmentation.errors.pattern)">(special characters are not allowed)</small>-->
                        <input type="text" class="form-control" id="CurrentSaveEmbryoGradingInfoRequest.Fragmentation "
                               [(ngModel)]="CurrentSaveEmbryoGradingInfoRequest.Fragmentation "
                               name="CurrentSaveEmbryoGradingInfoRequest.Fragmentation"
                               placeholder="Count" maxlength="5" minlength="1" #Fragmentation="ngModel" pattern="^[\0-9,._\-?]*$">
                        <small class="form-text text-danger"
                               *ngIf="(!Fragmentation.valid && (Fragmentation.dirty || Fragmentation.touched) && Fragmentation.errors.required)">(Field cannot be left blank)</small>
                        <small class="form-text text-danger"
                               *ngIf="(!Fragmentation.valid && Fragmentation.errors.pattern)">(only numbers are allowed)</small>
                      </div>
                    </div>


                  </div>
                </div>

                <div class="row">
                  <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                    <div class="row">
                      <div class="col-md-4 text-align-right margin-top-5px">
                        <label for="diaplayName">Remarks</label>
                      </div>
                      <div class="col-md-4 ">

                        <!--<input type="number" class="form-control"
                        placeholder="Details" maxlength="20" minlength="1" pattern="^[\sa-zA-Z0-9,._\-?]*$">-->
                        <!--<input type="number" class="form-control" id="CurrentSaveEmbryoGradingInfoRequest.Fragmentation "
                               [(ngModel)]="CurrentSaveEmbryoGradingInfoRequest.Fragmentation "
                               name="CurrentSaveEmbryoGradingInfoRequest.Fragmentation"
                               placeholder="Count" maxlength="20" minlength="1" #Fragmentation="ngModel" pattern="^[\sa-zA-Z0-9,._\-?]*$">
                        <small class="form-text text-danger"
                               *ngIf="(!Fragmentation.valid && (Fragmentation.dirty || Fragmentation.touched) && Fragmentation.errors.required)">(Field cannot be left blank)</small>
                        <small class="form-text text-danger"
                               *ngIf="(!Fragmentation.valid && Fragmentation.errors.pattern)">(special characters are not allowed)</small>-->
                        <textarea class="form-control3 size-2 width-inherit" rows="2" placeholder="Remarks"
                                  name="CurrentSaveEmbryoGradingInfoRequest.Remarks "
                                  [(ngModel)]="CurrentSaveEmbryoGradingInfoRequest.Remarks " required minlength="1" maxlength="100"
                                  #addconcerns_text1="ngModel"></textarea>
                        <small class="form-text text-danger"
                               *ngIf="(!addconcerns_text1.valid && (addconcerns_text1.dirty || addconcerns_text1.touched))">(Required)</small>

                      </div>
                    </div>


                  </div>
                </div>
              </div>
            </div>

          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-left-auto font-size-18px2" (click)="activeModal.close('Close click')">Close</button>
            <button type="submit" class="btn actions-btn-prime float-right font-size-18px margin-right-auto">Save</button>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
<div class="modal-signup modal-content" *ngIf="Mode=='Edit'">
  <div>
    <div class="card col-xl-12 col-lg-12 col-md-12 col-sm-12  my-profile-form document">


      <div class="card-header wh-header padding-bottom-0px">

        Edit Day<div class="badge badge-search-new margin-left-5px"><h4 class="margin-bottom-0px margin-top-1px">{{DOC}}</h4></div>

        <button type="button" class="close" data-dismiss="modal"
                (click)="activeModal.dismiss('Cross click')"
                aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="card-body padding-bottom-0px padding-right-0px margin-left-0px">
        <form class="form" novalidate="" (ngSubmit)="onSubmitEdit()" #f="ngForm">
          <div class="modal-body padding-top-0px">








            <div class="row margin-left-auto">
              <div class="col-md-12 padding-l-0px">

                <!--<div class="card-header wh-header card-header-bg padding-left-7px padding-top-6px margin-top-10">
                  Emergency Contact(Family)


                </div>-->
                <div class="row">
                  <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                    <div class="row">
                      <div class="col-md-4 text-align-right ">
                        <label for="diaplayName" *ngIf="DOC==1">Count</label>
                        <label for="diaplayName" *ngIf="DOC==2 || DOC==3 || DOC==4">Embryo Count</label>
                        <label for="diaplayName" *ngIf="DOC==5 || DOC==6">Blastomere Count</label>
                      </div>
                      <div class="col-md-4 ">
                        <CodeTypeValue CodeType="1to20" id="CurrentEditEmbryoGradingInfoRequest.EmbryoCount"
                                       [(ngModel)]="CurrentEditEmbryoGradingInfoRequest.EmbryoCount" SelectedValue="CurrentEditEmbryoGradingInfoRequest.EmbryoCount"
                                       name="CurrentEditEmbryoGradingInfoRequest.EmbryoCount" required>

                        </CodeTypeValue>

                      </div>
                    </div>


                  </div>
                </div>
                <div class="row" *ngIf="DOC==2">
                  <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                    <div class="row">
                      <div class="col-md-4 text-align-right ">
                        <label for="diaplayName">Cell Count</label>
                      </div>
                      <div class="col-md-4 ">

                        <!--<input type="number" class="form-control"
                        placeholder="Details" maxlength="20" minlength="1" pattern="^[\sa-zA-Z0-9,._\-?]*$">-->
                        <CodeTypeValue CodeType="1to20" id="CurrentEditEmbryoGradingInfoRequest.CellCount"
                                       [(ngModel)]="CurrentEditEmbryoGradingInfoRequest.CellCount" SelectedValue="CurrentEditEmbryoGradingInfoRequest.CellCount"
                                       name="CurrentEditEmbryoGradingInfoRequest.CellCount" required>

                        </CodeTypeValue>
                      </div>
                    </div>


                  </div>
                </div>
                <div class="row" *ngIf="DOC==3">
                  <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                    <div class="row">
                      <div class="col-md-4 text-align-right padding-left-0px">
                        <label for="diaplayName">Cell Count / Cell Stage</label>
                      </div>
                      <div class="col-md-4 ">

                        <!--<input type="number" class="form-control"
                        placeholder="Details" maxlength="20" minlength="1" pattern="^[\sa-zA-Z0-9,._\-?]*$">-->
                        <CodeTypeValue CodeType="CECNT" id="CurrentEditEmbryoGradingInfoRequest.CellStage"
                                       [(ngModel)]="CurrentEditEmbryoGradingInfoRequest.CellStage" SelectedValue="CurrentEditEmbryoGradingInfoRequest.CellStage"
                                       name="CurrentEditEmbryoGradingInfoRequest.CellStage" required>

                        </CodeTypeValue>
                      </div>
                    </div>


                  </div>
                </div>
                <div class="row" *ngIf="DOC==4">
                  <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                    <div class="row">
                      <div class="col-md-4 text-align-right margin-top-5px padding-left-0px">
                        <label for="diaplayName">Cell Count / Cell Stage</label>
                      </div>
                      <div class="col-md-4 ">

                        <!--<input type="number" class="form-control"
                        placeholder="Details" maxlength="20" minlength="1" pattern="^[\sa-zA-Z0-9,._\-?]*$">-->
                        <CodeTypeValue CodeType="CECNT" id="CurrentEditEmbryoGradingInfoRequest.CellStage"
                                       [(ngModel)]="CurrentEditEmbryoGradingInfoRequest.CellStage" SelectedValue="CurrentEditEmbryoGradingInfoRequest.CellStage"
                                       name="CurrentEditEmbryoGradingInfoRequest.CellStage" required>

                        </CodeTypeValue>
                      </div>
                    </div>


                  </div>
                </div>
                <div class="row" *ngIf="DOC==5 || DOC==6">
                  <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                    <div class="row">
                      <div class="col-md-4 text-align-right margin-top-5px">
                        <label for="diaplayName">Stage</label>
                      </div>
                      <div class="col-md-4 ">

                        <!--<input type="number" class="form-control"
                        placeholder="Details" maxlength="20" minlength="1" pattern="^[\sa-zA-Z0-9,._\-?]*$">-->
                        <CodeTypeValue CodeType="D{{DOC}}STG" id="CurrentEditEmbryoGradingInfoRequest.CellStage"
                                       [(ngModel)]="CurrentEditEmbryoGradingInfoRequest.CellStage" SelectedValue="CurrentEditEmbryoGradingInfoRequest.CellStage"
                                       name="CurrentEditEmbryoGradingInfoRequest.CellStage" required>

                        </CodeTypeValue>
                      </div>
                    </div>


                  </div>
                </div>
                <div class="row">
                  <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                    <div class="row">
                      <div class="col-md-4 text-align-right">
                        <label *ngIf="DOC==1">OutCome</label>
                        <label for="diaplayName" *ngIf="DOC==2 || DOC==3 || DOC==4">Grade</label>
                        <label for="diaplayName" *ngIf="DOC==5 || DOC==6">Grade (ICM+TE)</label>
                      </div>
                      <div class="col-md-3">
                        <CodeTypeValue CodeType="D{{DOC}}GR1" id="CurrentEditEmbryoGradingInfoRequest.Grade1"
                                       [(ngModel)]="CurrentEditEmbryoGradingInfoRequest.Grade1" SelectedValue="CurrentEditEmbryoGradingInfoRequest.Grade1"
                                       name="CurrentEditEmbryoGradingInfoRequest.Grade1" required></CodeTypeValue>

                      </div>
                      <div class="col-md-3" *ngIf="DOC>4">
                        <CodeTypeValue CodeType="D{{DOC}}GR2" id="CurrentEditEmbryoGradingInfoRequest.Grade2"
                                       [(ngModel)]="CurrentEditEmbryoGradingInfoRequest.Grade2" SelectedValue="CurrentEditEmbryoGradingInfoRequest.Grade2"
                                       name="CurrentEditEmbryoGradingInfoRequest.Grade2" required></CodeTypeValue>

                      </div>
                      <!--<div class="col-md-3" *ngIf="DOC>4">
                        <CodeTypeValue CodeType="D{{DOC}}GR3" id="CurrentEditEmbryoGradingInfoRequest.Grade3"
                                       [(ngModel)]="CurrentEditEmbryoGradingInfoRequest.Grade3" SelectedValue="CurrentEditEmbryoGradingInfoRequest.Grade3"
                                       name="CurrentEditEmbryoGradingInfoRequest.Grade3" required></CodeTypeValue>

                      </div>-->
                    </div>


                  </div>
                </div>
                <div class="row" *ngIf="DOC>1">
                  <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                    <div class="row">
                      <div class="col-md-4 text-align-right ">
                        <label for="diaplayName">Frozen</label>
                      </div>
                      <div class="col-md-4 ">

                        <!--<input type="number" class="form-control"
                        placeholder="Details" maxlength="20" minlength="1" pattern="^[\sa-zA-Z0-9,._\-?]*$">-->
                        <!--<input type="number" class="form-control" id="CurrentEditEmbryoGradingInfoRequest.FrozenCount"
                               [(ngModel)]="CurrentEditEmbryoGradingInfoRequest.FrozenCount"
                               name="CurrentEditEmbryoGradingInfoRequest.FrozenCount"
                               placeholder="Count" maxlength="20" minlength="1" #Ntimes="ngModel" pattern="^[\sa-zA-Z0-9,._\-?]*$">
                        <small class="form-text text-danger"
                               *ngIf="(!Ntimes.valid && (Ntimes.dirty || Ntimes.touched) && Ntimes.errors.required)">(Field cannot be left blank)</small>
                        <small class="form-text text-danger"
                               *ngIf="(!Ntimes.valid && Ntimes.errors.pattern)">(special characters are not allowed)</small>-->
                        <input type="text" class="form-control" id="CurrentEditEmbryoGradingInfoRequest.FrozenCount"
                               [(ngModel)]="CurrentEditEmbryoGradingInfoRequest.FrozenCount"
                               name="CurrentEditEmbryoGradingInfoRequest.FrozenCount"
                               placeholder="Count" maxlength="5" minlength="1" #Ntimes="ngModel" pattern="^[\0-9,._\-?]*$">
                        <small class="form-text text-danger"
                               *ngIf="(!Ntimes.valid && (Ntimes.dirty || Ntimes.touched) && Ntimes.errors.required)">(Field cannot be left blank)</small>
                        <small class="form-text text-danger"
                               *ngIf="(!Ntimes.valid && Ntimes.errors.pattern)">(only numbers are allowed)</small>
                      </div>
                    </div>


                  </div>
                </div>
                <div class="row" *ngIf="DOC>1">
                  <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                    <div class="row">
                      <div class="col-md-4 text-align-right ">
                        <label for="diaplayName">Discarded</label>
                      </div>
                      <div class="col-md-4 ">

                        <!--<input type="number" class="form-control"
                        placeholder="Details" maxlength="20" minlength="1" pattern="^[\sa-zA-Z0-9,._\-?]*$">-->
                        <!--<input type="number" class="form-control" id="CurrentEditEmbryoGradingInfoRequest.DiscardedCount"
                               [(ngModel)]="CurrentEditEmbryoGradingInfoRequest.DiscardedCount"
                               name="CurrentEditEmbryoGradingInfoRequest.DiscardedCount"
                               placeholder="Count" maxlength="20" minlength="1" #Ntimes="ngModel" pattern="^[\sa-zA-Z0-9,._\-?]*$">
                        <small class="form-text text-danger"
                               *ngIf="(!Ntimes.valid && (Ntimes.dirty || Ntimes.touched) && Ntimes.errors.required)">(Field cannot be left blank)</small>
                        <small class="form-text text-danger"
                               *ngIf="(!Ntimes.valid && Ntimes.errors.pattern)">(special characters are not allowed)</small>-->
                        <input type="text" class="form-control" id="CurrentEditEmbryoGradingInfoRequest.DiscardedCount"
                               [(ngModel)]="CurrentEditEmbryoGradingInfoRequest.DiscardedCount"
                               name="CurrentEditEmbryoGradingInfoRequest.DiscardedCount"
                               placeholder="Count" maxlength="5" minlength="1" #Ntimes="ngModel" pattern="^[\0-9,._\-?]*$">
                        <small class="form-text text-danger"
                               *ngIf="(!Ntimes.valid && (Ntimes.dirty || Ntimes.touched) && Ntimes.errors.required)">(Field cannot be left blank)</small>
                        <small class="form-text text-danger"
                               *ngIf="(!Ntimes.valid && Ntimes.errors.pattern)">(only numbers are allowed)</small>
                      </div>
                    </div>


                  </div>
                </div>
                <div class="row" *ngIf="DOC>1">
                  <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                    <div class="row">
                      <div class="col-md-4 text-align-right ">
                        <label for="diaplayName">Transfer</label>
                      </div>
                      <div class="col-md-4 ">

                        <!--<input type="number" class="form-control"
                        placeholder="Details" maxlength="20" minlength="1" pattern="^[\sa-zA-Z0-9,._\-?]*$">-->
                        <CodeTypeValue CodeType="1to20" id="CurrentEditEmbryoGradingInfoRequest.TransferCount"
                                       [(ngModel)]="CurrentEditEmbryoGradingInfoRequest.TransferCount" SelectedValue="CurrentEditEmbryoGradingInfoRequest.TransferCount"
                                       name="CurrentEditEmbryoGradingInfoRequest.TransferCount" required></CodeTypeValue>

                      </div>
                    </div>


                  </div>
                </div>
                <div class="row" *ngIf="Doc==1 || DOC==2 || DOC==3 || DOC==4">
                  <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                    <div class="row">
                      <div class="col-md-4 text-align-right margin-top-5px">
                        <label for="diaplayName">Fragmentation</label>
                      </div>
                      <div class="col-md-4 ">

                        <!--<input type="number" class="form-control"
                        placeholder="Details" maxlength="20" minlength="1" pattern="^[\sa-zA-Z0-9,._\-?]*$">-->
                        <!--<input type="number" class="form-control" id="CurrentEditEmbryoGradingInfoRequest.Fragmentation "
                               [(ngModel)]="CurrentEditEmbryoGradingInfoRequest.Fragmentation "
                               name="CurrentEditEmbryoGradingInfoRequest.Fragmentation"
                               placeholder="Count" maxlength="20" minlength="1" #Fragmentation="ngModel" pattern="^[\sa-zA-Z0-9,._\-?]*$">
                        <small class="form-text text-danger"
                               *ngIf="(!Fragmentation.valid && (Fragmentation.dirty || Fragmentation.touched) && Fragmentation.errors.required)">(Field cannot be left blank)</small>
                        <small class="form-text text-danger"
                               *ngIf="(!Fragmentation.valid && Fragmentation.errors.pattern)">(special characters are not allowed)</small>-->
                        <input type="text" class="form-control" id="CurrentEditEmbryoGradingInfoRequest.Fragmentation "
                               [(ngModel)]="CurrentEditEmbryoGradingInfoRequest.Fragmentation "
                               name="CurrentEditEmbryoGradingInfoRequest.Fragmentation"
                               placeholder="Count" maxlength="5" minlength="1" #Fragmentation="ngModel" pattern="^[\0-9,._\-?]*$">
                        <small class="form-text text-danger"
                               *ngIf="(!Fragmentation.valid && (Fragmentation.dirty || Fragmentation.touched) && Fragmentation.errors.required)">(Field cannot be left blank)</small>
                        <small class="form-text text-danger"
                               *ngIf="(!Fragmentation.valid && Fragmentation.errors.pattern)">(only numbers are allowed)</small>
                      </div>
                    </div>


                  </div>
                </div>

                <div class="row">
                  <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                    <div class="row">
                      <div class="col-md-4 text-align-right margin-top-5px">
                        <label for="diaplayName">Remarks</label>
                      </div>
                      <div class="col-md-4 ">

                        <!--<input type="number" class="form-control"
                        placeholder="Details" maxlength="20" minlength="1" pattern="^[\sa-zA-Z0-9,._\-?]*$">-->
                        <!--<input type="number" class="form-control" id="CurrentSaveEmbryoGradingInfoRequest.Fragmentation "
                               [(ngModel)]="CurrentSaveEmbryoGradingInfoRequest.Fragmentation "
                               name="CurrentSaveEmbryoGradingInfoRequest.Fragmentation"
                               placeholder="Count" maxlength="20" minlength="1" #Fragmentation="ngModel" pattern="^[\sa-zA-Z0-9,._\-?]*$">
                        <small class="form-text text-danger"
                               *ngIf="(!Fragmentation.valid && (Fragmentation.dirty || Fragmentation.touched) && Fragmentation.errors.required)">(Field cannot be left blank)</small>
                        <small class="form-text text-danger"
                               *ngIf="(!Fragmentation.valid && Fragmentation.errors.pattern)">(special characters are not allowed)</small>-->
                        <textarea class="form-control3 size-2 width-inherit" rows="2" placeholder="Address Line1"
                                  name="CurrentEditEmbryoGradingInfoRequest.Remarks "
                                  [(ngModel)]="CurrentEditEmbryoGradingInfoRequest.Remarks" required minlength="1" maxlength="100"
                                  #addconcerns_text2="ngModel"></textarea>
                        <small class="form-text text-danger"
                               *ngIf="(!addconcerns_text2.valid && (addconcerns_text2.dirty || addconcerns_text2.touched))">(Required)</small>

                      </div>
                    </div>


                  </div>
                </div>

              </div>
            </div>

          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-left-auto font-size-18px2" (click)="activeModal.close('Close click')">Close</button>
            <button type="submit" class="btn actions-btn-prime float-right font-size-18px margin-right-auto">Save</button>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
